<template>
  <v-container fluid v-if="user">
    <v-container>
      <v-card>
        <v-card-title class="text-center teal lighten-3 accent-4 white--text">
          Productos de Documento
        </v-card-title>
        <v-row class="mx-2 mt-1">
          <v-col cols="12" lg="3" md="3">
            <v-select
              v-model="sucursalSelected"
              :items="sucursales"
              :item-value="(item) => item"
              label="Sucursal"
              placeholder="Selecciona sucursal"
            ></v-select>
          </v-col>
          <v-col cols="12" lg="3" md="3">
            <v-autocomplete label="Serie" v-model="serie" :items="serieSearch">
            </v-autocomplete>
          </v-col>
          <v-col cols="12" lg="3" md="3">
            <v-text-field label="Folio" v-model="folio" clearable />
          </v-col>
          <v-col cols="2">
            <v-btn @click="getDocumento" small class="mt-5">Buscar</v-btn>
          </v-col>
        </v-row>

        <v-row class="mx-2 mt-1" v-if="detallesArray.length">
          <!-- Detalles de documento -->
          <v-card-title class="text-center"
            >Detalles del Documento</v-card-title
          >
          <v-row>
            <v-col cols="12" lg="12" md="12" class="text-left ml-4">
              <p class="text-left mb-2 mr-4">
                <strong>Serie - Folio:</strong> {{ detallesDocumento.serie }} -
                {{ detallesDocumento.folio }}
              </p>
            </v-col>
            <v-col cols="12" lg="12" md="12" class="text-left ml-4">
              <p class="text-left mb-2 mr-4">
                <span
                  v-for="detail in fechaConceptoModelo"
                  :key="detail.key"
                  class="mr-4"
                >
                  <strong>{{ detail.label }}:</strong>
                  {{ detail.value || "(Ninguno)" }}
                </span>
              </p>
            </v-col>
            <v-col cols="12" lg="12" md="12" class="text-left ml-4 mr-4">
              <p class="text-left mb-2 mr-4">
                <span
                  v-for="detail in razonRfcAgente"
                  :key="detail.key"
                  class="mr-4"
                >
                  <strong>{{ detail.label }}:</strong>
                  {{ detail.value || "(Ninguno)" }}
                </span>
              </p>
            </v-col>
            <v-col cols="12" lg="12" md="12" class="text-left ml-4 mr-4">
              <p class="text-left mb-2 mr-4">
                <span
                  v-for="detail in referenciaObservacionesUsuario"
                  :key="detail.key"
                  class="mr-4"
                >
                  <strong>{{ detail.label }}:</strong>
                  {{ detail.value || "(Ninguno)" }}
                </span>
              </p>
            </v-col>
            <v-col cols="12" lg="12" md="12" class="text-left ml-4 mr-4">
              <p class="text-left mt-2 mr-4">
                <span
                  v-for="detail in precioDetails"
                  :key="detail.key"
                  class="mr-4"
                >
                  <strong>{{ detail.label }}:</strong>
                  {{ detail.value || "(Ninguno)" }}
                </span>
              </p>
            </v-col>
            <v-col cols="12" lg="12" md="12" class="text-left ml-4 mr-4">
              <p class="text-left mt-2 mr-4">
                <span
                  v-for="detail in booleanDetails"
                  :key="detail.key"
                  class="mr-4"
                >
                  <strong>{{ detail.label }}:</strong>
                  {{ detail.value || "(Ninguno)" }}
                </span>
                <span
                  v-for="detail in estadoContable"
                  :key="detail.key"
                  class="mr-4"
                >
                  <strong>{{ detail.label }}:</strong>
                  {{ detail.value || "(Ninguno)" }}
                </span>
              </p>
            </v-col>
          </v-row>

          <v-col cols="12" lg="3" md="3">
            <v-text-field
              v-if="productosDocumento.length"
              label="Búsqueda"
              v-model="search"
              append-icon="mdi-magnify"
              clearable
            />
          </v-col>
          <v-col cols="12" lg="6" md="6"> </v-col>
          <v-col cols="12" lg="3" md="3" class="text-right">
            <v-btn
              v-if="productosDocumento.length"
              class="mt-6"
              color="primary"
              @click="downloadExcel"
            >
              Descargar Excel
            </v-btn>
          </v-col>
        </v-row>
        <v-data-table
          v-if="productosDocumento.length"
          :headers="headers"
          :items="productosDocumento"
          :search="search"
          :footer-props="{ 'items-per-page-text': 'Productos por página' }"
          :header-props="{ 'sort-by-text': 'Ordenar por' }"
          no-data-text="No se encontraron productos"
          no-results-text="No se encontraron productos"
          :items-per-page="-1"
        ></v-data-table>
      </v-card>
    </v-container>
  </v-container>
</template>

<script>
import axios from "axios";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import moment from "moment";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      serie: "",
      serieSearch: [
        "MXL-EN-TS",
        "MXL-EN-C",
        "MXL-EN-A",
        "MXL-EN-O",
        "MXL-SA-TS",
        "MXL-SA-A",
        "MXL-SA-C",
        "MXL-SA-O",
        "MXL-TR-CE",
        "MXL-TR-MO",
        "MXL-TR-O",
        "TIJ-EN-TS",
        "TIJ-EN-C",
        "TIJ-EN-A",
        "TIJ-EN-O",
        "TIJ-SA-TS",
        "TIJ-SA-A",
        "TIJ-SA-C",
        "TIJ-SA-O",
        "ENS-EN-TS",
        "ENS-EN-C",
        "ENS-EN-A",
        "ENS-EN-O",
        "ENS-SA-TS",
        "ENS-SA-A",
        "ENS-SA-C",
        "ENS-SA-O",
        "HER-EN-TS",
        "HER-EN-C",
        "HER-EN-A",
        "HER-EN-O",
        "HER-SA-TS",
        "HER-SA-A",
        "HER-SA-C",
        "HER-SA-O",
        "OBR-EN-TS",
        "OBR-EN-C",
        "OBR-EN-A",
        "OBR-EN-O",
        "OBR-SA-TS",
        "OBR-SA-A",
        "OBR-SA-C",
        "OBR-SA-O",
        "LPZ-EN-TS",
        "LPZ-EN-C",
        "LPZ-EN-A",
        "LPZ-EN-O",
        "LPZ-SA-TS",
        "LPZ-SA-A",
        "LPZ-SA-C",
        "LPZ-SA-O",
        "MXL-NC-D",
        "TIJ-NC-D",
        "ENS-NC-D",
        "OBR-NC-D",
        "HER-NC-D",
        "LPZ-NC-D",
      ],
      folio: "",
      productosDocumento: [],
      detallesDocumento: [],
      search: "",
      loading: false,
      sucursalSelected: null,
      sucursales: [
        {
          text: "Mexicali",
          value: "Mexicali",
        },
        {
          text: "Tijuana",
          value: "Tijuana",
        },
        {
          text: "Ensenada",
          value: "Ensenada",
        },
        {
          text: "La Paz",
          value: "La Paz",
        },
        {
          text: "Obregon",
          value: "Obregon",
        },
        {
          text: "Hermosillo",
          value: "Hermosillo",
        },
      ],
      headers: [
        {
          text: "Codigo Producto",
          value: "codigo_producto",
        },
        {
          text: "Nombre Producto",
          value: "nombre_producto",
        },
        {
          text: "Cantidad",
          value: "cantidad",
        },
      ],
    };
  },
  methods: {
    async getDocumento() {
      this.loading = true;
      try {
        const response = await axios.get(
          `/reportes/productos_de_documento?sucursal=${this.sucursalSelected.value}&serie=${this.serie}&folio=${this.folio}`
        );
        this.productosDocumento = response.data.productos_de_documento;
        this.detallesDocumento = response.data.detalles_de_documento;
      } catch (error) {
        console.error("Error al obtener el kardex:", error);
      } finally {
        this.loading = false;
      }
    },
    async downloadExcel() {
      try {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("Productos Documento");

        const currentDate = new Date().toLocaleString();

        // Encabezados personalizados con estilos en negritas
        worksheet.addRow(["Productos Documento"]).font = { bold: true };

        worksheet.addRow([`Sucursal: ${this.sucursalSelected.value}`]).font = {
          bold: true,
        };
        this.detallesArray.forEach((detail) => {
          worksheet.addRow([
            `${detail.label}: ${detail.value || "(Ninguno)"}`,
          ]).font = {
            bold: true,
          };
        });
        worksheet.addRow([
          `Fecha de descarga del reporte: ${currentDate}`,
        ]).font = {
          bold: true,
        };

        // Fila en blanco
        worksheet.addRow([]);

        // Encabezados de la tabla
        const headers = ["Codigo Producto", "Nombre Producto", "Cantidad"];
        const headerRow = worksheet.addRow(headers);

        // Aplicar negritas a los encabezados de la tabla
        headerRow.font = { bold: true };

        // Agregar los datos de la tabla
        this.productosDocumento.forEach((documento) => {
          worksheet.addRow([
            documento.codigo_producto,
            documento.nombre_producto,
            documento.cantidad,
          ]);
        });

        // Ajustar el ancho de las columnas automáticamente
        worksheet.columns.forEach((column) => {
          column.width = column.header ? column.header.length + 5 : 20;
        });

        // Generar y guardar el archivo Excel
        const buffer = await workbook.xlsx.writeBuffer();
        saveAs(
          new Blob([buffer]),
          `Productos_Documento${this.sucursalSelected.value}.xlsx`
        );
      } catch (error) {
        console.error("Error al generar el archivo Excel:", error);
      }
    },
  },
  mounted() {},
  watch: {},
  created() {},
  components: {},
  computed: {
    ...mapGetters(["user"]),
    detallesArray() {
      const labels = {
        serie: "Serie",
        folio: "Folio",
        fecha: "Fecha",
        concepto: "Concepto",
        modelo: "Modelo",
        razon_social: "Razón Social",
        rfc: "RFC",
        agente: "Agente",
        usuario: "Usuario",
        referencia: "Referencia",
        observaciones: "Observaciones",
        afectado: "Afectado",
        impreso: "Impreso",
        cancelado: "Cancelado",
        devuelto: "Devuelto",
        estado_contable: "Estado Contable",
        neto: "Neto",
        ieps: "IEPS",
        iva: "IVA",
        total: "Total",
        pendiente: "Pendiente",
      };
      return Object.keys(this.detallesDocumento).map((key) => {
        let value = this.detallesDocumento[key];
        if (typeof value === "boolean") {
          value = value ? "Sí" : "No";
        } else if (key === "fecha") {
          value = moment(value).format("DD/MM/YYYY");
        } else if (
          typeof value === "number" &&
          ["neto", "ieps", "iva", "total", "pendiente"].includes(key)
        ) {
          value = new Intl.NumberFormat("es-MX", {
            style: "currency",
            currency: "MXN",
          }).format(value);
        }
        return {
          key,
          label: labels[key] || key,
          value,
        };
      });
    },
    nonBooleanDetails() {
      return this.detallesArray.filter((detail) => {
        const type = typeof this.detallesDocumento[detail.key];
        return (
          type !== "boolean" &&
          ![
            "neto",
            "ieps",
            "iva",
            "total",
            "pendiente",
            "serie",
            "folio",
          ].includes(detail.key)
        );
      });
    },
    booleanDetails() {
      return this.detallesArray.filter(
        (detail) => typeof this.detallesDocumento[detail.key] === "boolean"
      );
    },
    precioDetails() {
      return this.detallesArray.filter((detail) =>
        ["neto", "ieps", "iva", "total", "pendiente"].includes(detail.key)
      );
    },
    fechaConceptoModelo() {
      return this.detallesArray.filter((detail) =>
        ["fecha", "concepto", "modelo"].includes(detail.key)
      );
    },
    razonRfcAgente() {
      return this.detallesArray.filter((detail) =>
        ["razon_social", "rfc", "agente"].includes(detail.key)
      );
    },
    referenciaObservacionesUsuario() {
      const order = ["usuario", "referencia", "observaciones"];
      return order
        .map((key) => this.detallesArray.find((d) => d.key === key))
        .filter(Boolean);
    },
    estadoContable() {
      return this.detallesArray.filter((detail) =>
        ["estado_contable"].includes(detail.key)
      );
    },
  },
};
</script>
<style scoped></style>
